<ng-container *ngIf="displayLocation == 'OAOPostApp'">
  <div [hidden]="!isDataLoaded" class="bl-font-color--base">
    <header class="bl-margin-bottom--24">
      <div class="bl-display--flex bl-align-items--center">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M14 0L18.3269 9.21688L28 10.6948L21 17.8685L22.652 28L14 23.2169L5.348 28L7 17.8685L0 10.6948L9.67307 9.21688L14 0Z"
            fill="#FFD065"
          />
        </svg>
        <h2 class="bl-text-style--display-6 bl-text-transform--capitalize bl-margin-bottom--0 bl-margin-left--16">
          {{ 'crossSell/header' | dictionary }}
        </h2>
      </div>
      <p class="bl-font-color--steel bl-margin-bottom--0">{{ 'crossSell/sub-header-post-app' | dictionary }}</p>
    </header>
    <ng-container *ngTemplateOutlet="crossSellCard"> </ng-container>
  </div>
</ng-container>

<ng-container *ngIf="displayLocation == 'OLAPostApp'">
  <div
    [hidden]="!isDataLoaded"
    class="bl-font-color--base bl-padding-top--32 bl-padding-bottom--48 bl-padding-x--16 bl-padding-x-sm--0"
  >
    <header class="bl-margin-bottom--24">
      <div class="bl-display--flex bl-align-items--center">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M14 0L18.3269 9.21688L28 10.6948L21 17.8685L22.652 28L14 23.2169L5.348 28L7 17.8685L0 10.6948L9.67307 9.21688L14 0Z"
            fill="#FFD065"
          />
        </svg>
        <h2 class="bl-text-style--display-6 bl-text-transform--capitalize bl-margin-bottom--0 bl-margin-left--16">
          {{ 'crossSell/header' | dictionary }}
        </h2>
      </div>
      <p class="bl-font-color--steel bl-margin-bottom--0">{{ 'crossSell/sub-header-post-app' | dictionary }}</p>
    </header>

    <ng-container *ngTemplateOutlet="crossSellCard"> </ng-container>
  </div>
</ng-container>

<ng-template #crossSellCard>
  <div id="cross-sell-cards-container" class="bl-display--block bl-display-sm--flex">
    <ng-container *ngFor="let item of crossSellProducts?.refinanceOpportunities">
      <div class="bl-padding-right-sm--32 bl-padding-bottom--16">
        <dx-cross-sell-card
          [refinanceOffers]="item"
          class="bl-position--sticky"
          (ctaActionEmit)="onLoanClick($event)"
          (openCrossSellPanel)="openCrossSellSlideInPanel($event)"
        ></dx-cross-sell-card>
      </div>
    </ng-container>

    <ng-container *ngFor="let item of crossSellProducts?.newCreditOffers">
      <div class="bl-padding-right-sm--32 bl-padding-bottom--16">
        <dx-cross-sell-card
          [newCreditOffers]="item"
          class="bl-position--sticky"
          (ctaActionEmit)="onLoanClick($event)"
          (openCrossSellPanel)="openCrossSellSlideInPanel($event)"
        ></dx-cross-sell-card>
      </div>
    </ng-container>
  </div>
</ng-template>
<ea-slide-in-panel class="full-panel" [(isSlidePanelVisible)]="openSlideInPanel" [slidePanelTitle]="docTitle">
  <div *ngIf="showStipulationsOnSlideIn" class="bl-font-weight--400 bl-text-align--left">
    <ul>
      <li *ngFor="let stipulation of stipulationList" class="cross-sell-stipulation">{{ stipulation }}</li>
    </ul>
  </div>
  <div [innerHTML]="termsAndConditionsText" *ngIf="isContentLoaded"></div>
  <ng-container *ngIf="pdfURL && isContentLoaded">
    <div class="bl-padding--16 bl-position--relative">
      <ecp-pdf-embed [pdfSrc]="pdfURL"></ecp-pdf-embed>
    </div>
  </ng-container>
  <ng-container *ngIf="!isContentLoaded">
    <ecp-content-spinner [spinnerSmall]="false"></ecp-content-spinner>
  </ng-container>
</ea-slide-in-panel>
